/* ------------------------------------------------------------------------ *\
 * User Content
\* ------------------------------------------------------------------------ */

import ScrollHint from "scroll-hint";

if (document.querySelector(".weblinx-table-container")) {
    new ScrollHint(".weblinx-table-container");
}
